import { render, staticRenderFns } from "./uppMigration.vue?vue&type=template&id=4389118d&scoped=true&"
import script from "./uppMigration.vue?vue&type=script&lang=js&"
export * from "./uppMigration.vue?vue&type=script&lang=js&"
import style0 from "./uppMigration.vue?vue&type=style&index=0&id=4389118d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4389118d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
